import { ReactComponent as Campaign } from "assets/icons/Campaign.svg";
import { ReactComponent as KakaoIcon } from "assets/icons/kakao.svg";
import { ReactComponent as AppleIcon } from "assets/icons/apple.svg";
import { ReactComponent as NaverIcon } from "assets/icons/naver.svg";
import { ReactComponent as UserIcon } from "assets/icons/Users-1.svg";
import { ReactComponent as WarningCircleIcon } from "assets/icons/WarningCircle.svg";
import ButtonComp from "components/ButtonCmp";
import MainHeader from "layouts/components/Header";
import * as S from "./style";

import { Image, Modal, message } from "antd";
import { getClientUserDetailApi, updateRequestDeleteApi } from "api/user";
import { ReactComponent as CakeIcon } from "assets/icons/Cake.svg";
import { ReactComponent as EmailIcon } from "assets/icons/Email.svg";
import { ReactComponent as GenderIntersexIcon } from "assets/icons/GenderIntersex.svg";
import { ReactComponent as MapPinLineIcon } from "assets/icons/MapPinLine.svg";
import { ReactComponent as PhoneIcon } from "assets/icons/Phone.svg";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const accountTypeMapping: any = {
  NAVER: (
    <>
      <NaverIcon className="big-icon" />
      <span className="strong">Login with Naver</span>
    </>
  ),
  NORMAL: (
    <>
      <span className="strong">Login with email</span>
    </>
  ),
  KAKAO: (
    <>
      <KakaoIcon className="big-icon" />
      <span className="strong">Login with Kakao</span>
    </>
  ),
  APPLE: (
    <>
      <AppleIcon className="big-icon" />
      <span className="strong">Login with Kakao</span>
    </>
  ),
};

function DeleteAccountDetail() {
  const navigate = useNavigate();
  const { userId } = useParams<{ userId: string }>();
  const [dataDetail, setDataDetail] = useState<any>({});
  const [confirmVisible, setConfirmVisible] = useState<boolean>(false);

  const getClientUserDetail = async () => {
    if (userId) {
      const { data }: any = await getClientUserDetailApi({ id: +userId });
      if (data) {
        setDataDetail(data);
      }
    }
  };

  const handleUpdateRequestDelete = async (isDelete: boolean) => {
    if (userId) {
      try {
        const { data }: any = await updateRequestDeleteApi({
          id: +userId,
          isDelete,
        });
        if (data) {
          navigate("/users/client-user?tab=delete_account");
        } else {
          message.error("Update request failed!");
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    getClientUserDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Wrapper>
      <MainHeader
        backLink="/users/client-user?tab=delete_account"
        title="Delete Request detail"
        breadCrumb={[
          {
            title: "Client account",
            link: "/users/client-user",
            icon: <Campaign />,
          },
          {
            title: "Account detail",
          },
        ]}
        // rightBtn={
        //   <ButtonComp
        //     onClick={() => navigate(`/users/client-user/edit/${userId}`)}
        //     icon={<PencilIcon />}
        //   >
        //     Edit User acc
        //   </ButtonComp>
        // }
      />
      <S.Container>
        <S.Content>
          <S.Card>
            <S.Action>
              <div className="box-text">
                <h3>Delete Request</h3>
                <p>
                  Created at{" "}
                  {dayjs(dataDetail?.requestLeaveAt).format("YYYY/MM/DD HH:mm")}
                </p>
              </div>
              <div className="box-btn">
                <ButtonComp
                  onClick={() => setConfirmVisible(true)}
                  status="noBackground"
                >
                  Delete Account
                </ButtonComp>
                <ButtonComp onClick={() => handleUpdateRequestDelete(false)}>
                  Cancel request
                </ButtonComp>
              </div>
            </S.Action>
          </S.Card>
          <S.Card>
            <S.BoxAvatar>
              <Image
                src={dataDetail?.avatar}
                fallback="data:image/png;base64,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"
              />
              <h3>{dataDetail?.displayName}</h3>
              <p>
                Joining day:{" "}
                {dayjs(dataDetail?.registeredAt).format("YYYY/MM/DD")}
              </p>
            </S.BoxAvatar>
          </S.Card>
          <S.Card>
            <S.BoxInfo>
              <h4>User account </h4>
              <S.Line>
                <S.Label>
                  <UserIcon />
                  <span>User name</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.email}</span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>{accountTypeMapping[dataDetail.accountType]}</S.Label>
              </S.Line>
            </S.BoxInfo>
          </S.Card>
          <S.Card>
            <S.BoxInfo>
              <h4>Profile information</h4>
              <S.Line>
                <S.Label>
                  <UserIcon />
                  <span>Full name</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.displayName}</span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>
                  <CakeIcon />
                  <span>Date of birth</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.birthDate}</span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>
                  <GenderIntersexIcon />
                  <span>Gender</span>
                </S.Label>
                <S.Value>
                  <span>
                    {dataDetail?.gender === "MALE" ? "Male" : "Female"}
                  </span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>
                  <PhoneIcon />
                  <span>Phone number</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.verifiedPhoneNumber}</span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>
                  <EmailIcon />
                  <span>Email</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.email}</span>
                </S.Value>
              </S.Line>
              <S.Line>
                <S.Label>
                  <MapPinLineIcon />
                  <span>Address</span>
                </S.Label>
                <S.Value>
                  <span>{dataDetail?.address}</span>
                </S.Value>
              </S.Line>
            </S.BoxInfo>
          </S.Card>
        </S.Content>
      </S.Container>
      <Modal
        open={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        footer={false}
        width={460}
      >
        <S.ModalContent>
          <WarningCircleIcon />
          <h3>Are you Delete Account "{dataDetail?.userName}"?</h3>
          <S.ModalBtn>
            <ButtonComp
              status="noBackground"
              className="btn-cancel"
              onClick={() => setConfirmVisible(false)}
            >
              Cancel
            </ButtonComp>
            <ButtonComp
              style={{ backgroundColor: "#dd6b59", borderColor: "#dd6b59" }}
              className="btn-submit"
              htmlType="submit"
              onClick={() => {
                setConfirmVisible(false);
                handleUpdateRequestDelete(true);
              }}
            >
              Delete
            </ButtonComp>
          </S.ModalBtn>
        </S.ModalContent>
      </Modal>
    </S.Wrapper>
  );
}

export default DeleteAccountDetail;
